// Finans (C53–C57, FINANCE bayrağı): şoför ödemeleri, müşteri faturalama, fatura taslağı, ek km / ek sefer.
// Yollar /operasyon altına göre; her ekran `finance` izni + FINANCE bayrağıyla korunur (kapalıysa ekran hiç açılmaz).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const DriverPayments = load(() => import('./DriverPayments'), 'DriverPayments');
const DriverPaymentDetail = load(() => import('./DriverPaymentDetail'), 'DriverPaymentDetail');
const Billing = load(() => import('./Billing'), 'Billing');
const InvoiceDraft = load(() => import('./InvoiceDraft'), 'InvoiceDraft');
const ExtraCharges = load(() => import('./ExtraCharges'), 'ExtraCharges');

const opts = { flag: 'FINANCE' as const };

export const financeRoutes = (
  <>
    <Route path="finans/sofor-odemeleri" element={guard(DriverPayments, 'finance', opts)} />
    <Route path="finans/sofor-odemeleri/:id" element={guard(DriverPaymentDetail, 'finance', opts)} />
    <Route path="finans/faturalama" element={guard(Billing, 'finance', opts)} />
    <Route path="finans/faturalar/:id" element={guard(InvoiceDraft, 'finance', opts)} />
    <Route path="finans/ek-ucretler" element={guard(ExtraCharges, 'finance', opts)} />
  </>
);
